import { View } from "binder"
import { DistrictMonthlySaleBenefitsReportViewModel } from "./districtMonthlySaleBenefitsReport-viewModel"

export class DistrictMonthlySaleBenefitsReportView extends View<DistrictMonthlySaleBenefitsReportViewModel>{
    GetViewUniqueId(): string {
        return "V-E822C6E8-AC4F-4FE5-B332-D69CA72DB434"
    }
    loadHtml(): string {
        let element = require('./districtMonthlySaleBenefitsReport.html').default;
        let style = require('./districtMonthlySaleBenefitsReport.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set reportDate(v: moment.Moment) { this._reportDate = v; } public get reportDate(): moment.Moment { return this._reportDate;} private _reportDate: moment.Moment;
    
    async calculate(){
        return this.dataContext.calculate();
    }

}
